import { useRouter } from 'next/router';

type UseGetAuthToken = {
  creatorSlug?: string;
};

export type AuthToken = string | boolean;

export const useGetAuthToken = ({
  creatorSlug,
}: UseGetAuthToken): AuthToken => {
  const router = useRouter();

  const page = router.pathname;
  if (page === '/shared/[agency]') {
    const agencySlug = router.query.agency as string;
    return `agency-share-${agencySlug}`;
  }

  if (page === '/shared/talent/[creatorSlug]') {
    const creatorSlug = router.query.creatorSlug as string;
    return `creator-share-${creatorSlug}`;
  }

  if (page === '/shared/saved-list/[id]' && creatorSlug) {
    return `creator-share-${creatorSlug}`;
  }

  if (page === '/shared/t/[id]' && creatorSlug) {
    return `creator-share-${creatorSlug}`;
  }

  if (page === '/shared/media-kits/[id]' && creatorSlug) {
    return `creator-share-${creatorSlug}`;
  }

  if (page === '/shared/manager/[managerId]') {
    // This is manager's roster page
    const token = router.query.managerId as string;
    return token;
  }

  return false;
};
